import { getGameSize } from '../../Config/Levels';
import { Animation } from './Animation';
import Core from '../../Core/Core';

export class SkippableAnimation extends Animation {
    private readonly hitArea: PIXI.Sprite;

    constructor(pauseWithGame: boolean = false) {
        super({ pauseWithGame });
        this.hitArea = new PIXI.Sprite(PIXI.Texture.EMPTY);
        Core.component.addChild(this.hitArea);
    }

    public skip() {
        const timeLine = this.timeLine;
        const currentLabel = timeLine.currentLabel();
        const currentLabelTime = timeLine.getLabelTime(currentLabel);
        const targetLabel = timeLine.getLabelAfter(currentLabelTime);
        timeLine.seek(targetLabel, false);
    }

    public async play(): Promise<void> {
        const hitArea = this.hitArea;
        hitArea.width = getGameSize().gameWidth;
        hitArea.height = getGameSize().gameHeight;
        hitArea.interactive = true;
        hitArea.addListener('pointerup', this.skip.bind(this));
        await super.play();
        hitArea.destroy();
    }
}
